"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _system = require("@ori-ui/mui-bundle/system");
const breakpoints = (0, _system.createBreakpoints)({
  values: {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536
  }
});
var _default = exports.default = breakpoints;
